<style lang="scss" scoped>
.trade-record-container {
  width: 702px;
  margin: 48px auto 0;
  .title {
    font-size: 28px;
    line-height: 40px;
    color: #1d1d1d;
    margin-bottom: 22px;
    height: 40px;
    position: relative;
    font-weight: bold;
    .more {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 24px;
      line-height: 34px;
      color: #1d1d1d;
      display: flex;
      justify-content: center;
      align-items: center;
      .arrow-icon {
        height: 26px;
        width: 14px;
        margin-left: 8px;
        // margin-top: -4px;
      }
    }
  }
  .split-container {
    display: flex;
    .line-start {
      height: 2px;
      width: 146px;
      box-sizing: border-box;
      border: 1px solid #1d1d1d;
    }
    .line-end {
      width: 580px;
      height: 2px;
      box-sizing: border-box;
      border: 1px solid #eeeeee;
    }
  }

  .trade-list {
    margin-top: 24px;
    .odd {
      background: #ffffff;
    }
    .even {
      background: #f6f6f6
    }
    .trade-item {
      height: 82px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      .avator {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        .img {
          object-fit: cover;
          height: 100%;
          width: 100%;
        }
      }
      .name {
        font-size: 24px;
        color: #999999;
        margin-left: 10px;
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .grade-container {
        width: 150px;
        text-align: center;
        display: flex;
        align-items: center;
        .grade {
          display: inline-block;
          height: 28px;
          font-size: 18px;
          color: #8ab1e9;
          line-height: 28px;
          padding: 0 4px;
          box-sizing: border-box;
          border: 1px solid #8ab1e9;
          border-radius: 2px;
          display: flex;
          align-items: center;
          // margin: 10px 4px 0 0;
        }
      }
      .price {
        font-size: 24px;
        color: #2d2d2d;
        width: 150px;
      }
      .time {
        flex: 1;
        text-align: right;
        font-size: 24px;
        color: #999999;
      }
    }
  }
}
</style>

<template>
  <div class="trade-record-container">
    <div class="title">交易记录
      <div v-if="tradeCount > 5" class="more" @click="goRecord">全部{{tradeCount}}
        <img class="arrow-icon" src="./../../../assets/images/ai-picture/arrow-right.png">
      </div>
    </div>
    <div class="trade-list">
      <div :class="'trade-item ' + (index%2===0 ? 'even': 'odd')" v-for="(record, index) in tradeList" :key="index">
        <div class="avator">
          <img class="img" :src="record.avatarHDImage">
        </div>
        <div class="name">{{record.buyerNickname}}</div>
        <div class="grade-container">
          <div class="grade">{{record.newsName}}</div>
        </div>
        <div class="price">￥{{record.actualPrice/100}}</div>
        <div class="time">{{record.orderTime.split(' ')[0]}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // recommendCount: 0,
    tradeList: {
      default: () => {
        return []
      }
    },
    tradeCount: {
      default: () => {
        return 0
      }
    },
    skcInfo: {
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    goRecord () {
      this.$router.push(`ai-picture/trade-record?skcInfo=${JSON.stringify(this.skcInfo)}`);
    }
  }
}
</script>
